import React,{useState,useEffect,useCallback} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MailIcon from '@material-ui/icons/Mail';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import {Styles} from './Styles';
import Ajax from './Ajax';

interface Props {
    userId: string,
}
let tidHeader:any;
let isLockHeader:boolean = false;

const Header = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const [newsCount,setNewsCount] = useState(0)
    const count = useCallback(()=>{
        console.log("count");
		Ajax.send("news/count",{userId:props.userId},(res:any)=>{
            //console.log(res);
			if( res.ok ){
                setNewsCount(res.count);
			}
		});
    },[props]);

    const startTimer = useCallback(()=>{
        count();
        tidHeader = setInterval( ()=>{
            //console.log("timer");
            if( !isLockHeader ){
                isLockHeader = true;
                count();
                isLockHeader = false;
            }
        },10000);
    },[count]);
    const stopTimer = ()=>{
        clearInterval(tidHeader);
    }
    const clear = ()=>{
        setNewsCount(0);
    }
    useEffect( ()=>{
        startTimer();
        return ()=>{
            //console.log("leave");
            stopTimer();
        }
    },[startTimer]);

    const toNews = "/news?cid=" + Math.random()*1000;
    const toGuide = "/guide";

	return (
        <AppBar position="absolute" className={classes.AppBar}>
            <Toolbar variant="dense" className={classes.Toolbar}>
                <div><Tooltip title="タイムラインに戻る"><Link to="/" className={classes.primaryText} style={{textDecoration:"none"}}><span className={classes.withIcon}><HowToVoteIcon/>GannenTanka!</span></Link></Tooltip></div>
                <div className={classes.grow} />

                <Tooltip title="説明とか"><Link to={toGuide}><IconButton aria-label="config" color="inherit">
                <ContactSupportIcon style={{color:"white"}}/>
                </IconButton></Link></Tooltip>

                <Tooltip title="お知らせ"><Link to={toNews} onClick={clear}><IconButton aria-label="config" color="inherit">
                <Badge badgeContent={newsCount} color="error">
                    <MailIcon style={{color:"white"}}/>
                </Badge>
                </IconButton></Link></Tooltip>
            </Toolbar>
        </AppBar>
	);
}

export default Header;
